<template>
  <v-form ref="form" @submit.prevent="submit" v-model="formValid">
    <v-row>
      <v-col cols="auto" class="pr-3">
        <BaseButton
          color="whiteSmoke"
          width="14"
          height="30"
          icon
          @click="previousStep"
        >
          <v-icon color="primary" size="14"> fa-chevron-left </v-icon>
        </BaseButton>
      </v-col>
      <v-col cols="10">
        <p class="gray--text" style="margin-top: 2px;">
          VOLTAR
        </p>
      </v-col>
      <v-col cols="10">
        <p class="gray--text font-weight-bold quotation-title">
          {{ titlePage }}
        </p>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field v-model="selectedResource" disabled outlined dense />
      </v-col>
    </v-row>
    <v-row v-if="withoutRecursal">
      <v-col cols="12" sm="6" class="pb-5">
        <BaseMoney
          id-element="valueResourceQuotation"
          placeholder="R$ 1.000,00"
          v-model="formResource.valor_importancia_segurada"
          label-text="Importância Segurada"
          :error-messages="errorMessages"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        class="pl-sm-5 pb-5"
        v-if="submodalityType.id === 'judicial_trabalhista'"
      >
        <div class="pa-3 resource-form__div">
          <p class="mb-2 primary--text font-weight-bold resource-form__title">
            *Percentual de Agravo
          </p>
          <p class="caption primary--text mb-0">
            Nas garantias para Execuções Trabalhistas é <b>obrigatório</b> o
            acréscimo de, no mínimo, 30% sobre o valor da condenação, observados
            os limites descritos na Lei 8.177 e IN 3 do TST, conforme art. 3º,
            II, do Ato Conjunto TST.CSJT.CGJT 1/2019.
          </p>
        </div>
      </v-col>
      <v-col cols="12">
        <BaseFormTextArea
          id-element="descriptionResourceQuotation"
          placeholder="Descreva"
          v-model="formResource.composicao_importancia_segurada"
          required
          :rules="[requiredInput, maxLengthTextArea]"
          label-text="Composição da Importância Segurada"
          text-information="Aqui você deve descrever o que compõe o valor da importância segurada, exemplo: valor de contrato, agravos previstos em processos, etc..."
          icon-information
        />
      </v-col>
    </v-row>
    <div v-else>
      <v-row class="pb-lg-12 mb-lg-12">
        <v-col cols="12" md="4" class="pr-md-5">
          <BaseFormInput
            id-element="valueResourceQuotation"
            placeholder="R$ 1.000,00"
            v-model.lazy="formResource.value"
            v-money="money"
            required
            :rules="ruleAccordingEmissionType"
            label-text="Valor de Depósito Recursal"
            text-information="É o valor requerido pela Justiça do Trabalho para admissão de um recurso, sendo uma das condições para garantir futura execução."
            icon-information
          />
        </v-col>
        <v-col cols="12" md="4" class="pr-md-5">
          <BaseFormInput
            id-element="percentResourceQuotation"
            placeholder="30%"
            v-model="formResource.percent"
            disabled
            label-text="Percentual de Agravo*"
          />
        </v-col>
        <v-col cols="12" md="4">
          <label
            for="calculateResourceQuotation"
            class="form__label primary--text"
          >
            Importância Segurada
          </label>
          <money
            v-model="calcInsuredAmount"
            v-bind="money"
            disabled
            class="resource-form__money"
            id="calculateResourceQuotation"
          />
        </v-col>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row class="pt-12 mt-6 pb-8">
        <v-col cols="12" class="pa-5 resource-form__div">
          <p class="mb-2 primary--text font-weight-bold resource-form__title">
            *Percentual de Agravo
          </p>
          <p class="caption primary--text mb-0">
            Nas garantias para Depósito Recursal é obrigatório o acréscimo de,
            no mínimo, 30% sobre o valor da condenação, observados os limites
            descritos na Lei 8.177 e IN 3 do TST, conforme art. 3º, II, do Ato
            Conjunto TST.CSJT.CGJT 1/2019. Nas garantias para Execução
            Trabalhista é obrigatório o acréscimo de, no mínimo, 30% sobre o
            valor executado a ser garantido, conforme art. 3º, I, do Ato
            Conjunto TST.CSJT.CGJT 1/2019.
          </p>
        </v-col>
      </v-row>
    </div>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-0 pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'PRÓXIMO'"
            class="white--text secondary"
            width="100%"
            :disabled="loading"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import { requiredInput, maxLengthTextArea } from "@/utils/rules.js";
import { asMoneyString } from "@/utils/formats.js";
export default {
  data: () => ({
    formValid: true,
    loading: false,
    requiredInput,
    maxLengthTextArea,
    asMoneyString,
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: false /* doesn't work with directive */
    },
    errorMessages: []
  }),
  computed: {
    ruleAccordingEmissionType() {
      return this.emissionType.id == "novo"
        ? [this.requiredInput, this.maxValue]
        : [this.requiredInput];
    },
    maxValue() {
      return (
        (this.formResource.insuredAmount / 1.3).toFixed(2) <= this.form.valor ||
        `O valor deve ser no máximo de ${asMoneyString(this.form.valor)}`
      );
    },
    formResource: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit("input", value);
      }
    },
    calcInsuredAmount: {
      get() {
        if (this.formResource.value) {
          const convertValue = isNaN(this.formResource.value)
            ? parseFloat(this.formResource.value.replace(/[\D]+/g, "")) / 100
            : this.formResource.value;
          return convertValue + convertValue * 0.3;
        } else {
          return "R$ 0,00";
        }
      },
      set(value) {
        this.formResource.insuredAmount = value;
      }
    },
    selectedResource() {
      return this.withoutRecursal
        ? `${this.emissionType.nome} - ${this.emissionType.subtitulo}`
        : this.form.nome || null;
    },
    titlePage() {
      return this.withoutRecursal ? "IMPORTÂNCIA SEGURADA" : "TIPO DE RECURSO";
    }
  },
  methods: {
    submit() {
      if (this.validate()) this.$emit("submit", this.formResource);
    },
    validate() {
      if (this.withoutRecursal) {
        let validateWithoutRecursal =
          this.formResource.valor_importancia_segurada > 0;
        this.errorMessages = validateWithoutRecursal
          ? []
          : ["Valor da importância segurada precisa ser maior que 0"];
        return validateWithoutRecursal && this.$refs.form.validate();
      } else {
        return this.$refs.form.validate();
      }
    },
    cancelQuotation() {
      this.$emit("cancel");
    },
    previousStep() {
      this.$emit("return");
    }
  },
  props: {
    form: {
      type: Object
    },
    value: {
      type: Object
    },
    emissionType: {
      type: Object
    },
    withoutRecursal: {
      type: Boolean,
      default: false
    },
    submodalityType: {
      type: Object
    }
  }
};
</script>
<style lang="sass" scoped>
.resource-form__
  &div
    border-radius: 4px
    background-color: #FFC55F
  &title
    font-size: 12px
  &money
    height: 40px
    padding: 0 12px
    border: 1px solid #D5D5E0 !important
    border-radius: 2px !important
    width: 100%
    margin-top: 8px
    background-color: #F0F0F7
    color: #676778
</style>
